import { Draw } from './draw';
import { BehaviorSubject, Observable } from 'rxjs';
import { Feature, Polygon } from 'geojson';
import area from '@turf/area';
import length from '@turf/length';
import { convertArea } from '@turf/helpers';

export type MapControl = 'distance' | 'area' | 'addressSearch';

export interface IMeasure {
  /**
   * Distance or area measurement result as a string containing the value and the unit
   */
  measureResult$: Observable<string>;
  getActiveControl: () => MapControl | null;
  setActiveControl: (control: MapControl | null) => void;
}

export default class Measure implements IMeasure {
  /**
   * Utilities for measuring area and distance on map
   */
  private draw: Draw;
  /**
   * Currently active tool
   */
  private activeControl: MapControl | null;

  private measureResult = new BehaviorSubject<string>('--.--');
  public measureResult$ = this.measureResult.asObservable();

  constructor(private map: mapboxgl.Map) {
    this.map.on('click', (e: mapboxgl.MapMouseEvent & mapboxgl.EventData) => {
    if (this.activeControl === 'area') {
      const polygonFeature: Feature<Polygon> = this.draw.polygon(e);
      if (polygonFeature) {
        const areaM2 = area(polygonFeature);
        const areaKm2 = convertArea(areaM2, 'meters', 'kilometers');
        if (areaKm2 > 0.1) {
          this.measureResult.next(areaKm2.toFixed(1) + ' km' + '\xB2');
        } else {
          this.measureResult.next(areaM2.toFixed(1) + ' m' + '\xB2');
        }
      }
    } else if (this.activeControl === 'distance') {
        const lineStringFeature = this.draw.line(e);
        if (lineStringFeature) {
          const distKilometer = length(lineStringFeature, {units: 'kilometers'});
          const distMeter = length(lineStringFeature, {units: 'meters'});
          if (distKilometer > 1) {
            this.measureResult.next(distKilometer.toFixed(1) + ' km');
          } else {
            this.measureResult.next(distMeter.toFixed(1) + ' m');
          }
        }
      }
    });
  }
  /**
   * Return currently activated tool
   */
  public getActiveControl() {
    return this.activeControl;
  }
  /**
   * Set active control
   */
  public setActiveControl(control: MapControl | null) {
    console.log('set control', control);
    if (this.draw) {
      this.draw.clear();
      this.measureResult.next('--.--');
    } else {
      this.draw = new Draw(this.map);
    }
    if (control === null || control === 'addressSearch') {
      this.map.getCanvas().style.cursor = null;
    } else {
      this.map.getCanvas().style.cursor = 'crosshair';
    }
    this.activeControl = control;
  }
}
